import { useEffect } from 'react';

const FONTS_URL =
  'https://fonts.googleapis.com/css2?' +
  'family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700' +
  '&family=IBM+Plex+Sans:wght@400;500;600' +
  '&family=JetBrains+Mono:wght@400;500' +
  '&display=swap';

/**
 * Lazy-loads Google Fonts (Fraunces, IBM Plex Sans, JetBrains Mono)
 * by injecting a <link> into <head>. Idempotent — checks data-hud-fonts attribute.
 */
export function useFontLoader(): void {
  useEffect(() => {
    if (document.querySelector('link[data-hud-fonts]')) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONTS_URL;
    link.dataset.hudFonts = '';
    document.head.appendChild(link);
  }, []);
}
